import React, { FC, ReactNode, ComponentProps } from 'react';

import PropTypes from 'prop-types';

import RadioButton from './RadioButton';

type RadioButtonBimAdapterProps = ComponentProps<typeof RadioButton> & {
  label?: ReactNode;
};

const RadioButtonBimAdapter: FC<RadioButtonBimAdapterProps> = ({
  label,
  ...rest
}) => {
  if (label) {
    return (
      <label
        css={[
          {
            display: 'flex',
            alignItems: 'center',
            '& span': {
              paddingLeft: '7px',
            },
          },
        ]}
      >
        <RadioButton {...rest} />
        <span>{label}</span>
      </label>
    );
  }

  return <RadioButton {...rest} />;
};

RadioButtonBimAdapter.propTypes = {
  /** The label of the RadioButton */
  label: PropTypes.node,
};

export default RadioButtonBimAdapter;
